module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-tabbed-vehicle-costs"
  }, [_c('CreateNoteModal', {
    attrs: {
      "entity": _vm.note.type,
      "entityId": _vm.$route.params.id
    },
    on: {
      "noteCreated": function($event) {
        return _vm.$refs.notesBaseList.loadData(1)
      }
    }
  }), _c('div', {
    staticClass: "container"
  }, [_c('base-list', {
    ref: "notesBaseList",
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "showPerPageSelect": false,
      "component-type": "entityList"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-350f4a5e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/ReservationNotes.vue
// module id = 2261
// module chunks = 1